import type { AgentTemplate } from "../types";
import { defineComponent } from "vue";
import Card from "@/components/primitives/cards/Cards";
import Icon from "@/components/ui/icon/Icon";
import { $t } from "@/services/i18n";
import { clickable } from "@/utils/a11y";
import { cn } from "@/utils/cn";
import { p } from "@/utils/props-builder";
import { TEMPLATE_CATEGORIES } from "../categories";
import DifficultyBadge from "./DifficultyBadge";

const props = {
  template: p.object<AgentTemplate>(),
  isBlank: p.boolean(false),
  onClick: p.$func<() => void>(),
};

export default defineComponent({
  name: "TemplateCard",
  props,
  setup(props) {
    return () => {
      // Card "Começar do Zero"
      if (props.isBlank) {
        return (
          <div
            class={cn(
              "cursor-pointer rounded-lg border-2 border-dashed bg-card transition-all hover:border-primary hover:bg-muted/50",
              "flex h-[180px] flex-col items-center justify-center p-6 text-center"
            )}
            {...clickable(() => props.onClick())}
          >
            <div class="mb-3 rounded-full bg-muted p-4">
              <Icon icon="lucide:plus" class="h-8 w-8 text-muted-foreground" />
            </div>
            <h3 class="font-semibold">{$t("agents:templates.start_from_scratch")}</h3>
            <p class="mt-1 text-sm text-muted-foreground">
              {$t("agents:templates.start_from_scratch_description")}
            </p>
          </div>
        );
      }

      const template = props.template!;
      const categoryMeta = TEMPLATE_CATEGORIES[template.category];

      return (
        <div
          class="h-[180px] cursor-pointer rounded-lg border bg-card transition-all hover:border-primary hover:shadow-md"
          {...clickable(() => props.onClick())}
          data-accent={categoryMeta.color}
        >
          <Card.Header class="pb-2">
            <div class="flex items-start justify-between">
              <div class="rounded-lg bg-accent-3 p-2" data-accent={categoryMeta.color}>
                <Icon icon={template.icon} class="h-6 w-6 text-accent-9" />
              </div>
              <DifficultyBadge difficulty={template.difficulty} />
            </div>
          </Card.Header>
          <Card.Content class="pt-0">
            <h3 class="font-semibold">{$t(template.nameKey as any)}</h3>
            <p class="mt-1 line-clamp-2 text-sm text-muted-foreground">
              {$t(template.descriptionKey as any)}
            </p>
          </Card.Content>
        </div>
      );
    };
  },
});
